<lfx-full-card [title]="project.name" [details]="project.description" [color]="project.colorBand"
    [logo]="project.logoUrl" [showOverlay]="showOverlayOnProjectCard">

    <lfx-dev-analytics-summary [contributors]="project.stats?.contributors" [contributions]="project.stats?.contributions"
        [chartColor]="project.colorBand" (hoverEvent)="onHoverStatistics($event)">
    </lfx-dev-analytics-summary>

    <lfx-dev-analytics-line-chart [chartColor]="project.colorBand" [showLinechart]="linechartOption"
        [chartData]="project.stats">
    </lfx-dev-analytics-line-chart>

</lfx-full-card>
